import React from "react";
import { Text, Image, RichText, Link } from "@sitecore-jss/sitecore-jss-react";
import { FindADealerProps } from "./fields.definitions";
import { FindADealerModel } from "./fields.model";
import "./style.scss";
import LocatorForm from "./LocatorForm";
import LazySection from '../../react-only-components/LazySection';

const FindADealer = (props: FindADealerProps) => {

  const model = new FindADealerModel(props);

  const hasLocatorFunctionality = false;

  return (
    <LazySection>
      <div className="find-a-dealer-wrapper">
        <div className="find-a-dealer">
          <div className="find-a-dealer__bg-image-wrapper">
            <Image
              field={model.backgroundImage}
              className="find-a-dealer__bg-image"
              loading='lazy'
            />
          </div>
          <div className="find-a-dealer__container">
            <Text
              field={model.title}
              className="find-a-dealer__text find-a-dealer__text--title is-title"
              tag="h2"
            />
            <RichText
              field={model.content}
              className="find-a-dealer__content"
            />
            {hasLocatorFunctionality ? (
              <LocatorForm model={model} />
            ) : (
              <pfe-cta
                pfe-priority="primary"
                class="find-a-dealer__cta find-a-dealer__cta--locator-page"
              >
                <Link field={model.searchButton} />
              </pfe-cta>
            )}
          </div>
        </div>
      </div>
    </LazySection>
  );
};

export default FindADealer;
